export const mailRecipients = {
    state: {
        recipients: [],
        status: 'idle'
    },
    mutations: {
        ADD_MAIL_RECIPIENT(state, payload) {
            state.recipients = [...state.recipients, payload]
        },
        SET_MAIL_RECIPIENTS(state, payload) {
            state.recipients = []
            state.recipients = payload
        },
        SET_MAIL_RECIPIENTS_STATUS(state, payload) {
            state.status = payload
        }
    },
    actions: {
        async loadMailRecipients({ state, commit }) {
            try {
                const res = await this.$api.get(
                    'merchant_notification_recipients'
                )

                if (!res.data?.data) {
                    return res
                }

                commit('SET_MAIL_RECIPIENTS', res.data.data)
            } catch (err) {
                console.log(err)
            }
        },

        async saveMailRecipient({ state, commit }, { email, merchant_id }) {
            try {
                const res = await this.$api.post(
                    'merchant_notification_recipients',
                    { email, merchant_id }
                )

                return res
            } catch (err) {
                console.log(err)
            }
        },

        async updateMailRecipient({ state, commit }, { id, email }) {
            try {
                const res = await this.$api.patch(
                    'merchant_notification_recipients/' + id,
                    { email }
                )

                return res
            } catch (err) {
                console.log(err)
            }
        },

        async deleteMailRecipient({ state, commit }, { id }) {
            try {
                const res = await this.$api.delete(
                    'merchant_notification_recipients/' + id
                )

                return res
            } catch (err) {
                console.log(err)
            }
        }
    },
    getters: {
        getMailRecipients: state => state.recipients
    }
}
